import { render, staticRenderFns } from "./zb_prop.vue?vue&type=template&id=4201e8ea&scoped=true"
import script from "./zb_prop.vue?vue&type=script&lang=ts"
export * from "./zb_prop.vue?vue&type=script&lang=ts"
import style0 from "./zb_prop.vue?vue&type=style&index=0&id=4201e8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4201e8ea",
  null
  
)

export default component.exports